import AgioLogo from '@/assets/icons/sidebar-logo.svg';
import {
  StyledCloseButton,
  StyledContentWrapper,
  StyledLogo,
  StyledWrapper,
} from './SimpleModalInfo.styled';
import { StyledAgioH3 } from '@/components/StyledSharedComponents/StyledTypography';
import { IModalAsSingleViewedBannerContentProps } from '@/types/modal';

export const SimpleModalInfo = ({
  closeModal,
  localStorageKey,
}: IModalAsSingleViewedBannerContentProps) => {
  const handleClick = () => {
    localStorage.setItem(localStorageKey, 'viewed');
    closeModal();
  };

  return (
    <StyledWrapper>
      <StyledLogo src={AgioLogo} alt="Agio logo" draggable={false} />
      <StyledContentWrapper>
        <StyledAgioH3 color="white.100">
          Circle (USDC) reserves modelling now live in our stablecoins portal.
        </StyledAgioH3>

        <StyledCloseButton onClick={handleClick}>Got it!</StyledCloseButton>
      </StyledContentWrapper>
    </StyledWrapper>
  );
};
